// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__Nw8gu","logo":"style_logo__IgdYv"};